import { useSelector } from 'react-redux'
import './index.scss'
import { RootState } from '../shared/Infraestructure/AdapterStore'
import { useEffect, useState } from 'react'
import { EntityMenu } from '../shared/Domain/EntityMenu'
import { LanguageTranslate } from '../shared/Infraestructure/LanguageTranslate'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { changeSaludo } from '../shared/Infraestructure/SliceGenerico'
import { configOperaciones } from './config'
import { AdapterGenerico } from '../shared/Infraestructure/AdapterGenerico'
// import { useVerifyAutoInventarioMutation } from '../shared/Infraestructure/slice'
// import { GetCodigoFechaActual } from 'sigo-package'
import { ViewLoading } from '../shared/Components/ViewLoading'

export function ViewOperacionesHome() {
    const { menu, user } = useSelector((state: RootState) => state.auth)
    const { autoInventario } = useSelector((state: RootState) => state.generico)
    const [options, setOptions] = useState<EntityMenu[]>([])
    const languageTranslate = LanguageTranslate()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { ROUTE_AUTO_INVENTARIO } = configOperaciones

    // const [verifyAutoInventario, { isLoading }] = useVerifyAutoInventarioMutation()

    useEffect(() => {
        const _menu = menu.filter(row => !row.esOpcion && row.sigla === 'SIGOAPP_OPERACIONES' && row.estado)
        setOptions(_menu)
    }, [menu])

    useEffect(() => {
        dispatch(changeSaludo(false))
        const _verifyAutoInventario = async () => {
            if (autoInventario) {
                await AdapterGenerico.createMessage('Información', 'Por favor, reporte autoinventario', 'info').then(() => navigate(ROUTE_AUTO_INVENTARIO))
            }
        }
        _verifyAutoInventario()
    }, [])

    const onClickMenu = (element: EntityMenu) => {
        navigate(`/${element.ruta}`, { replace: true });
    }

    // if (isLoading) return <ViewLoading />

    return (
        <div className="ViewLogisticaHome">
            <div className="container">
                {
                    options.map(row => (
                        <div className="row pb-3" key={row.id}>
                            <div className="col-12">
                                <div className='shadow-lg'
                                    style={{ width: '100%', padding: 5, margin: 0, borderRadius: '10px', cursor: 'pointer' }}
                                    onClick={() => onClickMenu(row)}>
                                    <div className="row">
                                        <div className="col-2">
                                            <button className='btn btn-secondary btn-icon-first' style={{ marginTop: '5px' }}>
                                                <i className={`text-white ${row.icono}`} />
                                            </button>
                                        </div>
                                        <div className="col-8">
                                            <span
                                                style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                {languageTranslate.menu[row.codigo as keyof typeof languageTranslate.menu].titulo}
                                            </span>
                                            <br />
                                            <span
                                                style={{ fontSize: '10px' }}>
                                                {languageTranslate.menu[row.codigo as keyof typeof languageTranslate.menu].descripcion}
                                            </span>
                                        </div>
                                        <div className="col-2 position-relative">
                                            <button className='btn btn-lg btn-secondary text-white text-center'>
                                                {">"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}